import { useMutation } from '@tanstack/react-query'
import { IExportClient, IUpdatePassword } from '../../../common/interfaces/client.interface'
import { customSwal } from '../../../config/swal'
import { ClientService } from '../../../services/ClientService'
import { openFile } from '../../../common/helpers/ExportHandlers'

export const useClients = () => {
  const upsertPasswordMutation = useMutation(
    (req: IUpdatePassword) => ClientService().upsertPasswordClient(req),
    {
      onSuccess: () => {
        customSwal.fire({
          icon: 'success',
          title: 'Contraseña actualizada correctamente.',
        })
      },
    }
  )

  const exportClient = useMutation(
    (req: IExportClient) => ClientService().exportClients(req),
    {
      onSuccess: (d: any) => {
        openFile(d, 'Listado de clientes');
      },
    }
  )

  return {
    mutations: {
      upsertPasswordMutation,
      exportClient
    },
  }
}
